import { useState, useCallback } from "react";
import { MoreVertical, FolderPlus } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { AddToCollectionSheet } from "@/components/AddToCollectionSheet";
import { useAuth } from "@/contexts/AuthContext";
import type { CollectionItemType } from "@/types/collections";

interface SaveToCollectionOverlayProps {
  itemId: string;
  itemType: CollectionItemType;
  itemVisibility?: "private" | "public";
}

export function SaveToCollectionOverlay({ itemId, itemType, itemVisibility }: SaveToCollectionOverlayProps) {
  const { isAuthenticated } = useAuth();
  const [sheetOpen, setSheetOpen] = useState(false);

  const handleTriggerClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  if (!isAuthenticated) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            onClick={handleTriggerClick}
            className="absolute right-3 top-3 z-20 p-1.5 rounded-full text-white/90 hover:text-white hover:bg-white/20 transition-colors"
            aria-label="More options"
          >
            <MoreVertical className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
        >
          <DropdownMenuItem onClick={() => setSheetOpen(true)}>
            <FolderPlus className="mr-2 h-4 w-4" />
            Save to collection
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {sheetOpen && (
        <AddToCollectionSheet
          open={sheetOpen}
          onOpenChange={setSheetOpen}
          items={[{ type: itemType, id: itemId }]}
          itemVisibility={itemVisibility}
        />
      )}
    </>
  );
}
